import React from 'react';
import classNames from 'classnames/bind';
import styles from './FindDebtReferenceSection.module.scss';
import { OpenChatBot } from 'utils/chatBot';
import { selectCurrentMarket } from 'features/core/selectors';
import { useAppSelector } from 'app/hooks';
import { Market } from 'common/consts/markets';
import PageLink from 'components/PageLink/PageLink';
interface Props {
  PageData?: any;
  Model?: any;
  handleClick: any;
}

const FindDebtReferenceSection = ({ PageData, Model, handleClick }: Props) => {
  const handleClose = () => {
    handleClick(false);
  };
  const liveBtn = () => {
    // OpenChatBot;
    OpenChatBot(Model?.WebchatPageUrl, PageData?.AnyQuestionsButtonText);
  };

  const currentMarket = useAppSelector(selectCurrentMarket);
  return (
    <div className="modal-overlay is-active">
      <div className="modal-dialog">
        <div className="modal-content">
          <a onClick={handleClose} className="modal-close"></a>
          <div className="modal-header">
            {' '}
            {PageData.FindReferenceToolTipHeading}
          </div>
          <div className="modal-body u-center">

            {PageData?.EnableWithoutReferenceLink ? 
            (
              <>
              <p className="modal-para">{PageData?.FindDebtReferencePopUpFirstPara} </p>

              <p className="modal-para">{PageData?.FindDebtReferencePopUpSecondPara}</p>
            
              <div className="Grid">
              <div className="Grid-cell">
              <PageLink
                        url={Model.VerifyIdentityWithoutReferenceUrl}
                        text={PageData.AlternateRegistrationButtonLabel}
                        className="Button u-block u-marginBxxsm"
                      />
              </div>
              </div>
              </>
            )
            :
            (
            <>
            <p className="modal-para">{PageData.FindReferenceToolTipContent}</p>

            <div className="Grid">
             { (currentMarket === Market.DE || currentMarket === Market.FR) &&
              
              (<div className="Grid-cell">
                
              </div>)
              }
              <div className="Grid-cell">
                <a
                  onClick={handleClose}
                  className="Button u-block u-marginBxxsm"
                  id="ok-button"
                >
                  <span> {PageData.FindReferenceToolTipButtonText}</span>
                </a>
              </div>
            </div>
            </>
            )
            
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindDebtReferenceSection;
